import * as register from '../actions/register';
import { CodeForm, MinimalRegisterForm } from '../models/register.model';
import * as fromCode from './register-code';
import * as fromEmail from './register-email';
import * as fromContract from './register-contract';

import { createFeatureSelector, createSelector } from '@ngrx/store';


export interface RegisterState {
  code: fromCode.State;
  email: fromEmail.State;
  contract: fromContract.State;
}


export const reducers = {
  code: fromCode.reducer,
  email: fromEmail.reducer,
  contract: fromContract.reducer,
};

export const selectRegisterState = createFeatureSelector<RegisterState>('register');



export const selectEmailState = createSelector(
  selectRegisterState,
  (state: RegisterState) => state.email,
);

export const selectCodeState = createSelector(
  selectRegisterState,
  (state: RegisterState) => state.code,
);

export const selectContractState = createSelector(
  selectRegisterState,
  (state: RegisterState) => state.contract,
);

export const getEmailPageForm = createSelector(
  selectEmailState,
  fromEmail.getForm,
);

export const getEmailPageError = createSelector(
  selectEmailState,
  fromEmail.getError,
);
export const getEmailPagePending = createSelector(
  selectEmailState,
  fromEmail.getPending,
);

export const getEmailPageSuccess = createSelector(
  selectEmailState,
  fromEmail.getSuccess,
);





export const getCodePageForm = createSelector(
  selectCodeState,
  fromCode.getForm,
);

export const getCodePageError = createSelector(
  selectCodeState,
  fromCode.getError,
);
export const getCodePagePending = createSelector(
  selectCodeState,
  fromCode.getPending,
);

export const getCodePageSuccess = createSelector(
  selectCodeState,
  fromCode.getSuccess,
);



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/auth/register/reducers/index.ts